<br>
  <div>
    <span class="headerText">Employees</span>
    <div style="float:right">
      <div>
        <div class="headerToggleDiv">
          <label for="showInactive">Show Not Employed</label>
          <p-checkbox binary="true" name="showInactive" [(ngModel)]="getInactives" (ngModelChange)="getEmployees()"></p-checkbox>
        </div>
        <p-button type="button" class="addNewButton" (click)="addNew();">Add New</p-button>
      </div>
    </div>
  </div>
<br/>
  <p-table showGridlines stripedRows responsiveLayout="stack" [columns]="cols" [value]="employees" [paginator]="true" [rows]="30">
    <ng-template pTemplate="header" let-columns>
      <tr>
        @for (col of columns; track col) {
          <th [pSortableColumn]="col.field" [style.width]="col.width">
            {{col.header}}
            @if (col.header != '') {
              <p-sortIcon [field]="col.field"  ariaLabel="Activate to sort" ariaLabelDesc="Activate to sort in descending order" ariaLabelAsc="Activate to sort in ascending order"></p-sortIcon>
            }
          </th>
        }
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-employee
      let-columns="columns"
      let-rowIndex="rowIndex">
      <tr>
        <td><span class="p-column-title">{{columns[0].header}}</span>{{employee.lastName}}</td>
        <td><span class="p-column-title">{{columns[1].header}}</span>{{employee.firstName}}</td>
        <td><span class="p-column-title">{{columns[2].header}}</span>{{employee.phoneNumber | phoneNumber}}</td>
        <td><span class="p-column-title">{{columns[3].header}}</span>{{employee.address.street}}</td>
        <td><span class="p-column-title">{{columns[4].header}}</span>{{employee.address.state.name}}</td>
        <td><span class="p-column-title">{{columns[5].header}}</span>{{employee.address.zip}}</td>
        <td><span class="p-column-title">{{columns[6].header}}</span>{{employee.currentlyEmployed == true ? 'Employed' : 'Not Employed'}}</td>
        <td>
          <p-button
            type="button"
            icon="pi pi-pencil"
            (click)="editEmployee(employee)"
            severity="info">
          </p-button>
          <p-button
            type="button"
            icon="pi pi-trash"
            (click)="deleteEmployee(employee)"
            severity="danger">
          </p-button>
        </td>
      </tr>
    </ng-template>
  </p-table>
